import { createTheme, darken, PaletteMode } from '@mui/material';

export const MONO_FONT = '"JetBrains Mono", "Fira Code", Consolas, "Courier New", monospace';

// Tool accent colors are pastel shades picked for the dark theme; darken them on light backgrounds.
export const toolAccent = (color: string, mode: PaletteMode) => (mode === 'light' ? darken(color, 0.35) : color);

const PALETTES = {
  dark: {
    primary: { main: '#90caf9' },
    secondary: { main: '#f48fb1' },
    background: { default: '#0b1120', paper: '#111827' },
    divider: 'rgba(148, 163, 184, 0.16)',
    text: { primary: '#e5e7eb', secondary: '#9ca3af' },
  },
  light: {
    primary: { main: '#1565c0' },
    secondary: { main: '#c2185b' },
    background: { default: '#f5f7fb', paper: '#ffffff' },
    divider: 'rgba(15, 23, 42, 0.12)',
    text: { primary: '#0f172a', secondary: '#475569' },
  },
};

export const createAppTheme = (mode: PaletteMode) => {
  const palette = PALETTES[mode];

  return createTheme({
    palette: { mode, ...palette },
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      button: {
        textTransform: 'none',
        fontWeight: 600,
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            border: `1px solid ${palette.divider}`,
          },
        },
        defaultProps: {
          elevation: 0,
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: { border: 'none' },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: { border: 'none' },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            '&:before': { display: 'none' },
            '&:not(:last-of-type)': { borderBottom: 'none' },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiInputBase: {
        styleOverrides: {
          inputMultiline: {
            fontFamily: MONO_FONT,
            fontSize: 14,
            lineHeight: 1.6,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 600 },
        },
      },
    },
  });
};
